import Breadcrumb from '@/components/breadcrumb';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useStore } from '@nanostores/react';
import { PlusIcon } from 'lucide-react';
import { NewOrgWorkflowDrawer } from './components/NewOrgWorkflowDrawer';
import { OrgWorkflowsListing } from './components/OrgWorkflowsListing';

export const ManageOrgWorkflows = () => {
  const [showDrawer, setShowDrawer] = useState(false);

  const org = useStore($org);

  const pages = [
    {
      label: org?.name || 'Organizations',
      href: org?.name ? `/organization/${org?.id}/workflows` : '/organizations',
    },
    {
      label: 'Workflows',
      href: `/organization/${org?.id}/workflows`,
    },
  ];

  return (
    <div>
      {/* Breadcrumb */}
      <h3 className="m-0 flex-1 p-0">
        <Breadcrumb pages={pages} />
      </h3>

      {/* Page Header with actions */}
      <div className=" mt-2 flex items-center justify-between space-y-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">{`Workflows`}</h2>
          <p className="text-muted-foreground">
            {`List of workflows for ${org?.name} Organization`}
            {/* <Badge className="mb-0 ml-2 mt-0">BETA</Badge> */}
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <Button onClick={() => setShowDrawer(true)}>
            <PlusIcon className="mr-2 h-4 w-4" /> Add New
          </Button>
        </div>
      </div>

      {/* Project list */}
      <div className="mt-4 max-w-6xl">
        <OrgWorkflowsListing />
      </div>

      {/* Create New Workflow Drawer */}
      <NewOrgWorkflowDrawer open={showDrawer} setOpen={setShowDrawer} />
    </div>
  );
};
